<template>
	<main-layout>
		<div class="content-body">
			<select v-model="profileSelected" v-on:change="changeProfile">
				<option disabled value="">Please select one</option>
				<template v-for="(profile,membershipId) of profiles">
					<option v-bind:value="profile.profile.membershipType">{{getMembershipTypeName(profile.profile.membershipType)}}</option>
				</template>
			</select>
			<div v-for="category in items" class="table-cell">
				<h2 v-on:click="toggleSection(category)">{{ category.name }}
					<span>Click to toggle</span>
				</h2>
				<template v-for="item in category.missing">
					<!-- <popper trigger="hover" :options="{placement: 'bottom'}">
						<div class="popper">
							<tooltip :data="item" :item-def="item" :type="'item'"></tooltip>
						</div>

						<item-node :data="item" slot="reference" :className="{acquired:item.acquired}"></item-node>
					</popper> -->
					<v-popover trigger="hover">
						<item-node :data="item" class="tooltip-target" :className="{acquired:item.acquired}"></item-node>
						<template slot="popover" class="popper">
							<tooltip :data="item" :item-def="item" :type="'item'"></tooltip>
						</template>
					</v-popover>
				</template>
				<template v-for="item in category.discovered">
					<!-- <popper trigger="hover" :options="{placement: 'bottom'}">
						<div class="popper">
							<tooltip :data="item" :item-def="item" :type="'item'"></tooltip>
						</div>

						<item-node :data="item" slot="reference" :className="{acquired:item.acquired}"></item-node>
					</popper> -->
					<v-popover trigger="hover">
						<item-node :data="item" class="tooltip-target" :className="{acquired:item.acquired}"></item-node>
						<template slot="popover" class="popper">
							<tooltip :data="item" :item-def="item" :type="'item'"></tooltip>
						</template>
					</v-popover>
				</template>
			</div>
		</div>
		<!-- <div class="layout-body"> -->
		<!-- <paginate v-bind:items="history" v-bind:className="'table'" v-bind:items-per-page="itemsPerPage">
			<template scope="props" slot="item">
				<div :key="props.itemKey" class="table-row">
					<div class="table-cell timestamp" v-bind:title="moment(props.item.timestamp).format('ddd[,] ll LTS')">{{ moment(props.item.timestamp).fromNow() }}</div>
					<div v-for="inventoryType in inventoryTypes" v-bind:class="['table-cell',inventoryType]" v-bind:title="inventoryType" v-if="props.item[inventoryType]">
						<template v-for="item in props.item[inventoryType]" v-if="">
							<popper trigger="hover" :options="{placement: 'bottom'}">
								<div class="popper" v-if="typeof item.itemHash !== 'undefined' && getItemDef(item)">
									<tooltip :data="item" :item-def="DestinyInventoryItemDefinition[item.itemHash]" :type="'item'"></tooltip>
								</div>
								<div class="popper" v-else-if="typeof item.progressionHash !== 'undefined' && getProgressionDef(item) && getProgressionDef(item).factionHash">
									<tooltip :data="item" :item-def="getFactionDef(getProgressionDef(item))" :type="'faction'"></tooltip>
								</div>
								<div class="popper" v-else-if="typeof item.progressionHash !== 'undefined' && getProgressionDef(item)">
									<tooltip :data="item" :item-def="getProgressionDef(item)" :type="'progression'"></tooltip>
								</div>
								<div class="popper" v-else-if="typeof item.factionHash !== 'undefined' && getFactionDef(item)">
									<tooltip :data="item" :item-def="getFactionDef(item)" :type="'faction'"></tooltip>
								</div>
								<div class="popper" v-else></div>

								<item-node :data="item" slot="reference"></item-node>
							</popper>
						</template>
					</div>
				</div>
			</template>
		</paginate> -->
		<!-- <paginate-links for="history" :limit="2" :show-step-links="true"></paginate-links> -->
		<!-- <virtual-scroller class="scroller" :items="history" item-height="70" :pool-size="3" :key-field="'timestamp'">
			<template scope="props" class="table">
				<div :key="props.itemKey" class="table-row">
					<div class="table-cell timestamp" v-bind:title="moment(props.item.timestamp).format('ddd[,] ll LTS')">{{ moment(props.item.timestamp).fromNow() }}</div>
					<div v-for="inventoryType in inventoryTypes" v-bind:class="['table-cell',inventoryType]" v-if="props.item[inventoryType]">
						<template v-for="item in props.item[inventoryType]">
							<popper trigger="hover" :options="{placement: 'bottom'}">
								<div class="popper" v-if="typeof item.itemHash !== 'undefined' && typeof DestinyInventoryItemDefinition[item.itemHash] !== 'undefined'">
									<tooltip :data="item" :item-def="DestinyInventoryItemDefinition[item.itemHash]"></tooltip>
								</div>
								<div class="popper" v-else></div>

								<item-node :data="item" slot="reference"></item-node>
							</popper>
						</template>
					</div>
				</div>
			</template>
		</virtual-scroller> -->
		<!-- <div v-for="itemDiff in history" class="table-row">
				<div class="table-cell">{{ moment(itemDiff.timestamp).format() }}</div>
				<div v-for="inventoryType in inventoryTypes" class="table-cell">
					<div v-for="item in itemDiff[inventoryType]" class="item-container">
						<div class="item" v-if="typeof item.itemHash !== 'undefined'" v-bind:style="'background-image:url(https://www.bungie.net' + DestinyInventoryItemDefinition[item.itemHash].icon + '),url(../assets/missing_icon.png)'"></div>
						<div class="faction" v-else-if="typeof item.progressionHash !== 'undefined' && DestinyProgressionDefinition[item.progressionHash].factionHash"
						    v-bind:style="'background-image:url(https://www.bungie.net' + DestinyFactionDefinition[DestinyProgressionDefinition[item.progressionHash].factionHash].factionIcon + ')'"></div>
						<div class="faction" v-else-if="typeof item.progressionHash !== 'undefined'" v-bind:style="'background-image:url(https://www.bungie.net' + DestinyProgressionDefinition[item.progressionHash].icon + ')'"></div>
						<div class="faction" v-else-if="typeof item.factionHash !== 'undefined'" v-bind:style="'background-image:url(https://www.bungie.net' + DestinyFactionDefinition[item.factionHash].factionIcon + ')'"></div>
						<div class="primary-stat" v-if="typeof item.primaryStat !== 'undefined'">{{ item.primaryStat.value }}</div>
						<div class="primary-stat" v-else-if="typeof item.objectives !== 'undefined'">{{ itemObjectivePercentage(item.objectives) }}%</div>
						<div class="primary-stat" v-else-if="typeof item.currentProgress !== 'undefined'">{{ item.currentProgress }}</div>
						<div class="primary-stat" v-else>{{ item.stackSize }}</div>
					</div>
				</div>
			</div> -->
		<!-- </div> -->
	</main-layout>
</template>

<style>
	h2 {
		cursor: pointer;
	}

	h2 span {
		font-size: 1.1em;
		font-weight: normal;
	}

	.acquired {
		opacity: 0.3;
	}

	.table-cell>span {
		display: inline-block
	}

	.content-body {
		display: grid;
		overflow-y: scroll;
		text-align: center;
	}

	.scroller {
		/* height: 100%; */
		height: calc(100% - 50px);
		width: 100%;
		overflow-y: scroll;
		box-sizing: border-box;
		padding: 2em;
	}

	.items {
		display: table;
		font-family: Arial, Helvetica, sans-serif;
	}

	.table-row {
		display: table-row;
	}

	.table-cell {
		display: inline-block;
		vertical-align: middle;
	}

	.table-cell.progression,
	.table-cell.added,
	.table-cell.removed,
	.table-cell.modified {
		padding: 0.5em 1em;
	}

	.table-cell.progression {
		background: rgba(200, 200, 200, 0.5)
	}

	.table-cell.added {
		background: rgba(0, 255, 0, 0.25)
	}

	.table-cell.removed {
		background: rgba(255, 0, 0, 0.25)
	}

	.table-cell.modified {
		background: rgba(0, 0, 255, 0.25)
	}

	.table-cell.progression::before,
	.table-cell.added::before,
	.table-cell.removed::before,
	.table-cell.modified::before {
		font-weight: bold;
		font-family: Arial, Helvetica, sans-serif;
		font-size: 46px;
		vertical-align: top;
	}

	.table-cell.progression::before {
		content: "%";
	}

	.table-cell.added::before {
		content: "+";
	}

	.table-cell.removed::before {
		content: "−";
	}

	.table-cell.modified::before {
		content: "#";
	}

	.table {
		display: table;
	}

	.v-popover {
		display: inline;
	}

	.tooltip {
		display: block!important;
		z-index: 10000
	}

	.tooltip .tooltip-arrow {
		width: 0;
		height: 0;
		border-style: solid;
		position: absolute;
		margin: 5px;
		border-color: #000;
		z-index: 1
	}

	.tooltip[x-placement^=top] {
		margin-bottom: 5px
	}

	.tooltip[x-placement^=top] .tooltip-arrow {
		border-width: 5px 5px 0;
		border-left-color: transparent!important;
		border-right-color: transparent!important;
		border-bottom-color: transparent!important;
		bottom: -5px;
		left: calc(50% - 5px);
		margin-top: 0;
		margin-bottom: 0
	}

	.tooltip[x-placement^=bottom] {
		margin-top: 5px
	}

	.tooltip[x-placement^=bottom] .tooltip-arrow {
		border-width: 0 5px 5px;
		border-left-color: transparent!important;
		border-right-color: transparent!important;
		border-top-color: transparent!important;
		top: -5px;
		left: calc(50% - 5px);
		margin-top: 0;
		margin-bottom: 0
	}

	.tooltip[x-placement^=right] {
		margin-left: 5px
	}

	.tooltip[x-placement^=right] .tooltip-arrow {
		border-width: 5px 5px 5px 0;
		border-left-color: transparent!important;
		border-top-color: transparent!important;
		border-bottom-color: transparent!important;
		left: -5px;
		top: calc(50% - 5px);
		margin-left: 0;
		margin-right: 0
	}

	.tooltip[x-placement^=left] {
		margin-right: 5px
	}

	.tooltip[x-placement^=left] .tooltip-arrow {
		border-width: 5px 0 5px 5px;
		border-top-color: transparent!important;
		border-right-color: transparent!important;
		border-bottom-color: transparent!important;
		right: -5px;
		top: calc(50% - 5px);
		margin-left: 0;
		margin-right: 0
	}

	.tooltip[aria-hidden=true] {
		visibility: hidden;
		opacity: 0;
		transition: opacity .15s, visibility .15s
	}

	.tooltip[aria-hidden=false] {
		visibility: visible;
		opacity: 1;
		transition: opacity .15s
	}

	.tooltip.popover .popover-arrow {
		border-color: #f9f9f9
	}
</style>

<script>
	import Vue from 'vue'
	import MainLayout from '../layouts/Main.vue'
	import Item from '../components/Item.vue'
	import Tooltip from '../components/Tooltip.vue'
	import VTooltip from 'v-tooltip'
	Vue.use(VTooltip)
	import localforage from 'localforage';
	import drive from '../shared/drive';
	for (let hash in DestinyFactionDefinition) {
		if (typeof DestinyFactionDefinition[hash].progressionHash === "number") {
			if (DestinyProgressionDefinition[DestinyFactionDefinition[hash].progressionHash]) {
				DestinyProgressionDefinition[DestinyFactionDefinition[hash].progressionHash].factionHash = hash;
				// console.log(`factionHash: ${hash}, progressionHash: ${DestinyFactionDefinition[hash].progressionHash}`)
			}
		}
	}


	export default {
		components: {
			'main-layout': MainLayout,
			'item-node': Item,
			'tooltip': Tooltip,
		},
		data: function () {
			let fullTiers = [44, 43, 42, 41, 39, 19];
			let partTiers = [49, 48, 47, 46, 45, 54, 13, 11, 10, 9, 14, 8, 7, 6, 5, 4, 3, 2];
			let items = [];
			for (let tier of fullTiers) {
				items.push({
					categoryHash: tier,
					name: DestinyItemCategoryDefinition[tier].shortTitle,
					tiers: [2, 3, 4, 5, 6],
					hashes: [],
					discovered: [],
					missing: []
				});
			}
			for (let tier of partTiers) {
				items.push({
					categoryHash: tier,
					name: DestinyItemCategoryDefinition[tier].shortTitle,
					tiers: [5, 6],
					hashes: [],
					discovered: [],
					missing: []
				});
			}
			return {
				DestinyInventoryItemDefinition: DestinyInventoryItemDefinition,
				DestinyFactionDefinition: DestinyFactionDefinition,
				DestinyProgressionDefinition: DestinyProgressionDefinition,
				DestinyItemCategoryDefinition: DestinyItemCategoryDefinition,
				DestinyVendorDefinition: DestinyVendorDefinition,
				ignorableItemCategoryHashes: [59, 58, 57, 56, 53, 52, 34, 18, 16],
				items: items,
				profiles: {},
				profileSelected: "",
				currentProfileData: {},
				membershipTypes: [],
				badHashes: [4248210736, 3921006356, 3921006354, 3921006353, 3450065543, 3450065541, 3450065540, 3450065536,
					1051938194, 1051938195, 1051938197, 1051938198, 3403116797, 3403116796, 3403116795, 3403116792, 2926662840,
					2926662839, 2926662837, 2926662836, 1298682514, 1298682515, 2926662834, 1489178152, 1489178155, 1489178156,
					1489178157, 2926662833, 2657932158, 2657932152, 2657932153, 2657932157, 4212410112, 776529033, 776529034,
					855333069, 855333070, 855333071, 1723894000, 1723894001, 1723894003, 776529032, 1940590819, 436053704, 436053704,
					938542991, 52780822, 269888150, 1180618054, 1261178282, 2349202967, 2363751990, 2827049491, 3625355092,
					3666208348, 3732622839, 599007201
				]
			};
		},
		created() {
			let self = this;
			drive.postAuth(function () {
				self.refresh()
			})
		},
		methods: {
			refresh: function () {
				let self = this;
				drive.getFile(drive.files.profiles).then(function (fileDetails) {
					if (fileDetails && fileDetails.data) {
						for (let membershipId of Object.keys(fileDetails.data)) {
							self.profiles[membershipId] = fileDetails.data[membershipId];
							if (self.membershipTypes.indexOf(self.profiles[membershipId].profile.membershipType) === -1) {
								self.membershipTypes.push(self.profiles[membershipId].profile.membershipType);
							}
							self.profileSelected = self.profiles[membershipId].profile.membershipType;
							self.currentProfileData = self.profiles[membershipId];
						}
					}
				});
			},
			changeProfile: function () {
				let self = this;
				drive.getFile(drive.files.profiles).then(function (fileDetails) {
					if (fileDetails && fileDetails.data) {
						for (let membershipId of Object.keys(fileDetails.data)) {
							self.profiles[membershipId] = fileDetails.data[membershipId];
							if (self.membershipTypes.indexOf(self.profiles[membershipId].profile.membershipType) === -1) {
								self.membershipTypes.push(self.profiles[membershipId].profile.membershipType);
							}
							if (self.profiles[membershipId].profile.membershipType === self.profileSelected) {
								self.currentProfileData = self.profiles[membershipId];
							}
						}
					}
				});
			},
			getMembershipTypeName(membershipType) {
				if (membershipType === 1) {
					return "XBOX";
				}
				if (membershipType === 2) {
					return "PLAYSTATION";
				}
				if (membershipType === 4) {
					return "BLIZZARD";
				}
			},
			toggleSection: function (category) {
				if (category.hashes.length) {
					category.hashes = [];
					category.discovered = [];
					category.missing = [];
				} else {
					console.log(this.currentProfileData);
					let acquiredItemHashes = [];
					for (let itemHash of Object.keys(DestinyInventoryItemDefinition)) {
						let item = DestinyInventoryItemDefinition[itemHash];
						item.itemHash = parseInt(itemHash);
						if (typeof item.itemCategoryHashes !== "undefined" && typeof item.inventory !== "undefined" && item.itemCategoryHashes
							.length > 0 && ((category.ignore59 && item.itemCategoryHashes.indexOf(59) === -1) || !category.ignore59) &&
							this.badHashes.indexOf(item.itemHash) === -1) {
							// for (let category of this.items) {
							if (item.itemCategoryHashes.indexOf(category.categoryHash) > -1) {
								if (category.tiers.indexOf(item.inventory.tierType) > -1) {
									category.hashes.push(item);
								}
								// break;
							}
							// }
						}
					}
					// for (let category of this.items) {
					category.hashes.sort(function (a, b) {
						return `${a.classType}${a.inventory.tierType}`.localeCompare(`${b.classType}${b.inventory.tierType}`);
					});
					// }
					// for (let characterId of Object.keys(this.currentProfileData.characterCompactInventories)) {
					// 	for (let itemId of Object.keys(this.currentProfileData.characterCompactInventories[characterId])) {
					// 		acquiredItemHashes.push(this.currentProfileData.characterCompactInventories[characterId][itemId].itemHash);
					// 	}
					// }
					// for (let kioskId of Object.keys(this.currentProfileData.kiosks)) {
					// 	for (let index of this.currentProfileData.kiosks[kioskId]) {
					// 		if (acquiredItemHashes.indexOf(DestinyVendorDefinition[kioskId].itemList[index].itemHash) === -1) {
					// 			acquiredItemHashes.push(DestinyVendorDefinition[kioskId].itemList[index].itemHash);
					// 		}
					// 	}
					// }
					// for (let category of this.items) {
					let displayedItemHashes = [];
					// for (let itemHash of acquiredItemHashes) {
					// 	for (let item of category.hashes) {
					// 		if (itemHash === item.itemHash) {
					// 			item.acquired = true;
					// 			category.discovered.push(item);
					// 			displayedItemHashes.push(itemHash);
					// 			break;
					// 		}
					// 	}
					// }
					for (let item of category.hashes) {
						if (displayedItemHashes.indexOf(item.itemHash) === -1) {
							item.acquired = false;
							category.missing.push(item);
						}
					}
					console.log(category)
					// }
				}
			},
			getItemDef(item) {
				return DestinyInventoryItemDefinition[item.itemHash];
			},
			getProgressionDef(item) {
				return DestinyProgressionDefinition[item.progressionHash];
			},
			getFactionDef(item) {
				return DestinyFactionDefinition[item.factionHash];
			}
		}
	}
</script>


// WEBPACK FOOTER //
// Collection.vue?33827bb5